import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FYProvider } from "./context/FYContext";
import YBFLayout from "./components/ybf/YBFLayout";
import Overview from "./pages/ybf/Overview";
import PillarPage from "./pages/ybf/PillarPage";
import Geography from "./pages/ybf/Geography";
import Partners from "./pages/ybf/Partners";
import Stories from "./pages/ybf/Stories";
import Beneficiaries from "./pages/ybf/Beneficiaries";
import "./App.css";

export default function App() {
  return (
    <FYProvider>
      <BrowserRouter>
        <YBFLayout>
          <Routes>
            <Route path="/"                 element={<Overview />} />
            <Route path="/stem"             element={<PillarPage pillarId="stem"           />} />
            <Route path="/digital"          element={<PillarPage pillarId="digital"        />} />
            <Route path="/employability"    element={<PillarPage pillarId="employability"  />} />
            <Route path="/sustainability"   element={<PillarPage pillarId="sustainability" />} />
            <Route path="/beneficiaries"    element={<Beneficiaries />} />
            <Route path="/geography"        element={<Geography />} />
            <Route path="/partners"         element={<Partners />} />
            <Route path="/stories"          element={<Stories />} />
            <Route path="*"                 element={<Overview />} />
          </Routes>
        </YBFLayout>
      </BrowserRouter>
    </FYProvider>
  );
}
